export const MUTED_VIDEO = 'MUTED_VIDEO'
export const VIDEO_APPEND = 'VIDEO_APPEND'
export const VIDEO_REMOVE = 'VIDEO_REMOVE'
export const RESET_VIDEOS_ACTION = 'RESET_VIDEOS_ACTION'
export const UPDATE_VIDEO_ACTIVE = 'UPDATE_VIDEO_ACTIVE'
export const ADD_IN_VIDEO_COLLECTION = 'ADD_IN_VIDEO_COLLECTION'
// Mutations
export const REMOVE_VIDEO_FROM_COLLECTION = 'REMOVE_VIDEO_FROM_COLLECTION'
export const SET_VIDEO_ACTIVE = 'SET_VIDEO_ACTIVE'
export const SAVE_MUTED_VIDEO = 'SAVE_MUTED_VIDEO'
export const RESET_VIDEOS = 'RESET_VIDEOS'
export const SET_PREV_POST_INDEX = 'SET_PREV_POST_INDEX'
export const SET_SCROLL_DIRECTION = 'SET_SCROLL_DIRECTION'



// WEBPACK FOOTER //
// ./src/store/actions/video.js